import { createContext, useContext, useMemo, useState } from "react"
const JobProfileDetailsContexts = createContext()

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 * @param {number} props.profileId - ID del perfil
 */
export function JobProfileDetailsContextsProvider({ children, profileId }) {
	const [reload, setReload] = useState(false)
	const [jobProfile, setJobProfile] = useState(null)
	const datos = useMemo(
		() => ({
			profileId,
			reload,
			refresh: () => setReload(!reload),
			jobProfile,
			setJobProfile,
		}),
		[jobProfile, profileId, reload]
	)
	return (
		<JobProfileDetailsContexts.Provider value={datos}>
			{children}
		</JobProfileDetailsContexts.Provider>
	)
}

/**
 * @typedef {Object} JobProfileContextParams
 * @property {boolean} reload
 * @property {JobProfileType|null} jobProfile
 * @property {number|null} profileId
 * @property {function():void} setJobProfile - actualiza el la información del perfil
 * @property {function():void} refresh - actualiza el reload
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {JobProfileContextParams}
 */

export function UseJobProfileDetailsContexts() {
	return useContext(JobProfileDetailsContexts)
}
